import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import api from '../../utils/api';
import LoadingSpinner from '../common/LoadingSpinner';
import toast from 'react-hot-toast';

const OrderSuccess = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrder();
  }, [id]);

  const fetchOrder = async () => {
    try {
      const { data } = await api.get(`/orders/${id}`);
      setOrder(data);
    } catch (error) {
      toast.error('Failed to load order details');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingSpinner />;
  if (!order) return <div>Order not found</div>;

  return (
    <div className="container mx-auto px-4 py-16 max-w-2xl">
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto mb-4" />
        
        <h1 className="text-3xl font-bold mb-2">Order Placed Successfully!</h1>
        <p className="text-gray-500 mb-2">Order #{order._id}</p>
        <p className="text-gray-500 mb-6">
          We'll send you a confirmation email shortly.
        </p>

        <div className="bg-gray-50 rounded-lg p-6 text-left mb-6">
          <h3 className="font-semibold mb-3">Order Details</h3>
          <div className="space-y-2">
            <p>
              <span className="font-medium">Status:</span>{' '}
              <span className="capitalize">{order.status}</span>
            </p>
            <p>
              <span className="font-medium">Total:</span> ${order.total.toFixed(2)}
            </p>
            <p>
              <span className="font-medium">Items:</span>{' '}
              {order.items.reduce((acc, item) => acc + item.quantity, 0)} items
            </p>
            <p>
              <span className="font-medium">Customer:</span> {order.customer.name}
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn-primary text-center">
            Continue Shopping
          </Link>
          <Link to="/products" className="btn-secondary text-center">
            Browse More Products
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;